class modalCadastralReferenceController {
  constructor (EventEmitter, $window) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  onChangeForm($event) {
    this.cadastralReference = $event.cadastralReference;
    this.isCadastralCorrect = $event.isCadastralCorrect;
  }

  conCloseModalCadastral() {
    let sendToClose = {
      cadastralReference: this.cadastralReference,
      isCadastralCorrect: this.isCadastralCorrect,
    };
    this.closeModalCadastral(this.EventEmitter(sendToClose));
  }

  onSaveCadastral($event) {
    this.onSave(this.EventEmitter($event));
  }

}

export default modalCadastralReferenceController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalCadastralReference/modalCadastralReference.controller.js